export = {
  statsInit: {
    ball_possession: 0,
    corner_kicks: 0,
    goals: 0,
    penalty: 0,
    assists: 0,
    red_cards: 0,
    yellow_cards: 0,
    shots: 0,
    shots_on_target: 0,
    passes: 0,
    passes_accuracy: 0,
    dribble: 0,
    dribble_succ: 0,
    clearances: 0,
    blocked_shots: 0,
    shots_off_target: 0,
    attacks: 0,
    dangerous_attack: 0,
    interceptions: 0,
    tackles: 0,
    key_passes: 0,
    crosses: 0,
    crosses_accuracy: 0,
    long_balls: 0,
    long_balls_accuracy: 0,
    duels: 0,
    duels_won: 0,
    fouls: 0,
    was_fouled: 0,
    goals_against: 0,
    offsides: 0,
    yellow2red_cards: 0,
    freekicks: 0,
    freekick_goals: 0,
    hit_woodwork: 0,
    fastbreaks: 0,
    fastbreak_shots: 0,
    fastbreak_goals: 0,
    poss_losts: 0,
  },
  techKind: {
    ball_possession: "TL kiểm soát bóng",
    corner_kicks: "Phạt góc",
    goals: "Bàn thắng",
    penalty: "Phạt đền",
    assists: "Kiến tạo",
    red_cards: "Thẻ đỏ",
    yellow_cards: "Thẻ vàng",
    shots: "Sút bóng",
    shots_on_target: "Sút cầu môn",
    passes: "Chuyền bóng",
    passes_accuracy: "Chuyền bóng thành công",
    dribble: "Rê bóng",
    dribble_succ: "Rê bóng thành công",
    clearances: "Đánh chặn",
    blocked_shots: "Cản bóng",
    shots_off_target: "Sút ngoài cầu môn",
    attacks: "Tấn công",
    dangerous_attack: "Tấn công nguy hiểm",
    interceptions: "Cắt bóng",
    tackles: "Tắc bóng",
    key_passes: "Chuyền bóng quan trọng",
    crosses: "Tạt bóng",
    crosses_accuracy: "Tạt bóng thành công",
    long_balls: "Chuyền dài",
    long_balls_accuracy: "Chuyền dài chính xác",
    duels: "Đối đầu",
    duels_won: "Đối đầu thành công",
    fouls: "Phạm lỗi",
    was_fouled: "Bị phạm lỗi",
    goals_against: "Bàn thua",
    offsides: "Việt vị",
    yellow2red_cards: "Thẻ vàng biến thành thẻ đỏ",
    freekicks: "Đá phạt trực tiếp",
    freekick_goals: "Bàn từ đá phạt",
    hit_woodwork: "Sút trúng cột dọc",
    fastbreaks: "Phản công nhanh",
    fastbreak_shots: "Sút trong phản công nhanh",
    fastbreak_goals: "Bàn từ phản công nhanh",
    poss_losts: "Mất bóng",
  },
};
